import { useQuery, UseQueryResult } from "react-query";

import { ApiRoutes } from "../../constants/ApiRoutes";
import { httpClient } from "../../api-legacy/BaseApi";

interface PublicEventsListParams {
  companyId: number;
  startDate?: number;
  endDate?: number;
  statusCode?: string;
  limit?: number;
}

export function useEventsCalendarQuery(
  params: PublicEventsListParams,
): UseQueryResult<any, Error> {
  return useQuery(
    ["app", "events", "calendar", params],
    () =>
      httpClient
        .get(ApiRoutes.EventsList, { params })
        .then(({ data }) => data),
    { enabled: !!params.companyId },
  );
}
